export default __webpack_public_path__ + "static/media/ShwetaJadhav.bdd89f98.png";